export default __webpack_public_path__ + "static/media/project4.1954ae57.jpg";